var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDsms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg6",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3e2723",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#5d4037",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#bg6)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 30)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 340,
    height: 240,
    rx: 8,
    fill: "#ffffff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 40,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#3e2723"
  }, "Data Structures"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60, 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    fill: "#5d4037",
    rx: 4
  }), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 25,
    textAnchor: "middle",
    fill: "#ffffff"
  }, "[ ]"), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 0,
    width: 40,
    height: 40,
    fill: "#5d4037",
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 20,
    r: 10,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 0,
    width: 40,
    height: 40,
    fill: "#5d4037",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 10 L150 30 M130 30 L150 10",
    stroke: "#ffffff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 160,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#3e2723"
  }, "Management System"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsms);
export default __webpack_public_path__ + "static/media/dsms.9d8ee2100f46b4d1fbfdc87b60519e10.svg";
export { ForwardRef as ReactComponent };